import { combineReducers, configureStore } from '@reduxjs/toolkit';
import booksReducer from './books/books';
import categoriesReducer from './categories/categories';

const rootReducer = combineReducers({ books: booksReducer, categories: categoriesReducer });
const store = configureStore({ reducer: rootReducer });
export default store;
